// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/:app_id/sdk_authentication_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdSdkAuthenticationSettings } from "./constants";
import type { AppsAppIdSdkAuthenticationSettingsResult } from "./types";

export const getAppsAppIdSdkAuthenticationSettings = reactQueryFetcherAdapter(
  appsAppIdSdkAuthenticationSettings,
  (signal: AbortSignal, appId: string): Promise<AppsAppIdSdkAuthenticationSettingsResult> => {
    if (appId) {
      return fetch(`/apps/${appId}/sdk_authentication_settings`, "GET", {}, { signal });
    }
  }
);
